import { Scale } from "../../utils/Scale"
import { OrganType } from "./sprites/EffectsWindow"
import { TmAtlas, TmImage, TmVideo } from "./TimeMachineAssets"

export class TmType {
    name: NicType
    nicName: NicName
    video: string
    videoX: number
    scan: string
    scanX: number
    scanY: number
    organs: Array<OrganInfo>
}

export class OrganInfo {
    organType: OrganType
    asset: string
    centerX?: boolean
    x?: number
    y: number
    textBottom?: boolean
}

export enum NicType {
    CHEWER = "CHEWER",
    SMOKER = "SMOKER",
    VAPER = "VAPER",
}

export enum NicName {
    CHEW = "chew",
    SMOKING = "smoking",
    VAPING = "vaping",
}

export const tmTypes = () => ({
    chewer: {
        name: NicType.CHEWER,
        nicName: NicName.CHEW,
        video: TmVideo.CHEWER_VIDEO,
        videoX: Scale.x(0.01),
        scan: TmAtlas.SCAN_CHEWER,
        scanX: Scale.x(0.052),
        scanY: Scale.y(0.172),
        organs: [
            {
                organType: OrganType.MOUTH,
                asset: TmImage.MOUTH,
                centerX: true,
                y: Scale.y(0.34),
                textBottom: true,
            },
            {
                organType: OrganType.STOMACH,
                asset: TmImage.STOMACH,
                x: Scale.x(0.285),
                y: Scale.y(0.6)
            },
            {
                organType: OrganType.ESOPHAGUS,
                asset: TmImage.ESOPHAGUS,
                centerX: true,
                y: Scale.y(0.41),
                textBottom: true,
            },
        ]
    },
    smoker: {
        name: NicType.SMOKER,
        nicName: NicName.SMOKING,
        video: TmVideo.SMOKER_VIDEO,
        videoX: Scale.x(-0.01),
        scan: TmAtlas.SCAN_SMOKER,
        scanX: Scale.x(0.035),
        scanY: Scale.y(0.215),
        organs: [
            {
                organType: OrganType.MOUTH,
                asset: TmImage.MOUTH,
                centerX: true,
                y: Scale.y(0.34)
            },
            {
                organType: OrganType.HEART,
                asset: TmImage.HEART,
                x: Scale.x(0.291),
                y: Scale.y(0.52),
                textBottom: true,
            },
            {
                organType: OrganType.LUNGS,
                asset: TmImage.LUNGS,
                centerX: true,
                y: Scale.y(0.504)
            },
        ]
    },
    vaper: {
        name: NicType.VAPER,
        nicName: NicName.VAPING,
        video: TmVideo.VAPER_VIDEO,
        videoX: Scale.x(-0.01),
        scan: TmAtlas.SCAN_VAPER,
        scanX: Scale.x(0.032),
        scanY: Scale.y(0.175),
        organs: [
            {
                organType: OrganType.MOUTH,
                asset: TmImage.MOUTH,
                centerX: true,
                y: Scale.y(0.34)
            },
            {
                organType: OrganType.HEART,
                asset: TmImage.HEART,
                x: Scale.x(0.291),
                y: Scale.y(0.52),
                textBottom: true,
            },
            {
                organType: OrganType.LUNGS,
                asset: TmImage.LUNGS,
                centerX: true,
                y: Scale.y(0.504)
            },
        ]
    },
})
